import React from "react";
import PropTypes from "prop-types";

import Typography from '@mui/material/Typography';

const B = ({ children }) => {
  return (
    <Typography
      sx={{
        display: "inline",
        fontWeight: "bold"
      }}
      component="span" 
    >
      {children}
    </Typography>
  )
}

B.propTypes = {
  children: PropTypes.node.isRequired,
}

export default B;
